import React from 'react';
import { InstagramIcon, MailIcon, GlobeIcon } from 'lucide-react';
const links = [{
  icon: MailIcon,
  label: 'Support via email',
  href: '#offer'
}, {
  icon: InstagramIcon,
  label: 'Instagram',
  href: '#offer'
}, {
  icon: GlobeIcon,
  label: 'Official website',
  href: '#offer'
}];
export function SiteFooter() {
  return <footer className="bg-noir py-12 sm:py-14" data-id="element-204" data-mp="3hhoh3rqsy10o">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-205" data-mp="3dgut6ydd0m7s">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between" data-id="element-206" data-mp="3difq2un5ch8t">
          <div className="max-w-md" data-id="element-207" data-mp="38gyrx6w1r8vx">
            <p className="font-display text-xl leading-snug text-gold-light sm:text-2xl" data-id="element-208" data-mp="38k4dic5gvsmw">
              Jazz Teacher&rsquo;s Arsenal&trade;
            </p>
            <p className="mt-2 text-sm text-paper-400" data-id="element-209" data-mp="2ykvo7wljr26v">
              The complete system for professional jazz educators.
            </p>
            <p className="mt-5 font-display text-base italic leading-snug text-gold-dark sm:text-lg" data-id="element-210" data-mp="11oxxy1peuu8a">
              Because teaching jazz shouldn&rsquo;t cost you every evening of the week.
            </p>
          </div>

          <nav aria-label="Footer" className="flex flex-col gap-3" data-id="element-211" data-mp="1apopl3fqiukn">
            {links.map(({
            icon: Icon,
            label,
            href
          }) => <a key={label} href={href} className="flex items-center gap-3 text-sm text-paper-300 transition-colors duration-150 ease-out hover:text-gold" data-id="element-212" data-mp="vtquzplglyaj">
                <Icon className="h-4 w-4 text-gold-dark" aria-hidden="true" data-id="element-213" data-mp="1ohv3eivf0pgx" />
                {label}
              </a>)}
          </nav>
        </div>

        <p className="mt-10 border-t border-wood-dark pt-6 text-[10px] uppercase tracking-label text-paper-400 sm:text-[11px]" data-id="element-214" data-mp="1esbk5c3sitlj">
          &copy; Jazz Teacher&rsquo;s Arsenal&trade; 2026 &mdash; All rights reserved.
        </p>
      </div>
    </footer>;
}